import "../../css/Content.css";
import AdminMenuId from "../../utils/constants/AdminMenuId";
import TablePage from "../table/TablePage";
import UserManagementPage from "./userManagement/UserManagementPage";
import PaymentPage from "./payment/PaymentPage";
import TeacherManagementPage from "./teacherManagement/TeacherManagementPage";

let AdminContent = (props) => {
    switch (props.currentMenu) {
        case AdminMenuId.TABLE:
            return <TablePage data={props.data} location={props.location} isAdmin={true}
                              myInformation={props.myInformation}></TablePage>;
        case AdminMenuId.USER_MANAGEMENT:
            return <UserManagementPage location={props.location}></UserManagementPage>;
        case AdminMenuId.REGISTER_PAYMENT:
            return <PaymentPage location={props.location}></PaymentPage>
        case AdminMenuId.TEACHER_MANAGEMENT:
            return <TeacherManagementPage location={props.location} data={props.data}></TeacherManagementPage>
        default:
            return null;
    }
}
export default AdminContent
